// extracted by css-extract-rspack-plugin
export default {"popover":"TQNOvWn5UKoXCMLq","dialog":"jTKIke_pzEOqTM2u"};